var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 54,
    height: 23,
    rx: 11.5,
    fill: "white",
    stroke: "#535353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5909 5.58492C31.7763 5.39948 31.9964 5.25238 32.2387 5.15201C32.481 5.05165 32.7407 5 33.003 5C33.2652 5 33.5249 5.05165 33.7672 5.15201C34.0095 5.25238 34.2296 5.39948 34.4151 5.58492C34.6005 5.77036 34.7476 5.99051 34.848 6.2328C34.9483 6.47509 35 6.73478 35 6.99703C35 7.25928 34.9483 7.51897 34.848 7.76126C34.7476 8.00355 34.6005 8.2237 34.4151 8.40915L24.8833 17.9409L21 19L22.0591 15.1167L31.5909 5.58492Z",
    stroke: "#535353",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditBig);
export default __webpack_public_path__ + "static/media/Icon_edit_big.96e60668580cd34d6e5e9113f4e68056.svg";
export { ForwardRef as ReactComponent };